import { useAtom, useAtomValue } from 'jotai';
import * as React from 'react';
import { useState } from 'react';

import { Button, Fade, LinearProgress, Stack } from '@mui/material';
import { artifactAtom } from '../../../stores/jotai/artifacts/artifacts';
import { baseAtom } from '../../../stores/jotai/base';
import MaterialTranscriptEditor from './material-transcript-editor';
import TranscriptUploader from './TranscriptUploader';
import { useFetchTranscriptData } from '../../../tanstackQuery/queries/editor';
import { useKeycloak } from '@react-keycloak/web';
import { useQueryClient } from '@tanstack/react-query';
import { discoverySessionAtom } from '../../../stores/jotai/discovery-session';
import { useGetAssemblies } from '../../../tanstackQuery/queries/assemblies';

export default function MaterialAudioTranscriber(props) {
    const { customFindingTypes } = props;
    const [base,] = useAtom(baseAtom);
    const [hasTranscript, setHasTranscript] = React.useState(false);
    // const [hasAssembly, setHasAssembly] = React.useState(false);
    const [hasAudio, setHasAudio] = React.useState(false);
    const [assemblyCache, setAssemblyCache] = React.useState(undefined);
    // const artifact = useAtomValue(artifactAtom);
    const [discoverySession] = useAtom(discoverySessionAtom);
    const [showTranscriptUploader, setShowTranscriptUploader] = useState(false);
    const { keycloak } = useKeycloak();
    const client = useQueryClient();
    const interviewID = base?.selectedInterview;

    const artifact = client.getQueryData([
      "artifacts",
      { groupID: base.team.groupID, sessionID: discoverySession?.sessionID },
    ]) as any[];

    const { data: assemblies } = useGetAssemblies(
        { accessToken: keycloak?.token },
        { groupID: base.team.groupID },
        { enabled: !!(base?.team?.groupID && discoverySession?.sessionID) }
    );

    // const transcript = artifact?.transcript
    //   ? artifact?.transcript?.[interviewID]
    //   : {};
    // const media = artifact?.media ? artifact.media?.[interviewID] : {};
    const transcript = React.useMemo(() => {
       return artifact?.transcript?.[interviewID] ?? {};
    }, [artifact, interviewID]);

    const media = React.useMemo(() => {
      return artifact?.media?.[interviewID] ?? {};
    }, [artifact, interviewID]);


    // const currentAssembly = assemblies?.find(
    //   (assembly) => assembly?.reservation === base.selectedInterview
    // );
    const keycloakToken = keycloak?.token;
    // console.log({ transcript,interviewID,base:base?.selectedInterview });

    const {
      data,
      isLoading: isFetchingTranscriptionData,
      isError,
      refetch,
    } = useFetchTranscriptData({
      transcriptDataURL: transcript?.artifactID,
      teamID: base?.team?.groupID,
      accessToken: keycloakToken,
    });

    React.useEffect(() => {
        setShowTranscriptUploader(true);
    }, []);

    React.useEffect(() => {
        let assemblyCheck = undefined;

        for (let i = 0; i < assemblies; i++) {
            if (assemblies[i]?.interviewID === base.selectedInterview) {
                assemblyCheck = assemblies[i];
            }
        }

        if (assemblyCheck !== undefined) {
             setAssemblyCache(assemblyCache);
            // setHasAssembly(false);
        }
    }, [base.selectedInterview, assemblies]);

    //let interview = base.interviews[base.selectedInterview];
    React.useEffect(() => {
        try {

            if (transcript.vultrKey !== undefined) {
                setHasTranscript(true);
            }
            else {
                setHasTranscript(false);
                // setHasAssembly(true);
            }
        }
        catch (e) {
            setHasTranscript(false);
            // setHasAssembly(true);
        }

        try {

            if (media.vultrKey !== undefined) {
                setHasAudio(true);
            }
            else {
                setHasAudio(false);
            }
        }
        catch (e) {
            setHasAudio(false);
        }

    }, [transcript.vultrKey, media.vultrKey]);

    const renderTranscriptEditor = () => {
        const transcript = artifact.transcript?.[interviewID];

        if (transcript === undefined && !hasAudio) {
            return <LinearProgress />
        }
        
        return (
          <Fade in={true} timeout={800}>
              <div>
                <MaterialTranscriptEditor
                    onSelectText={() => {}}
                    assemblies={assemblies}
                    transcriptMode={props.transcriptMode}
                    transcriptDataURL={transcript?.artifactID}
                    hasTranscript={hasTranscript}
                    customFindingTypes={customFindingTypes}
                    data={data} 
                    isFetchingTranscriptionData={isFetchingTranscriptionData} 
                    isError={isError}
                    refetch={refetch}
                />
             </div>
          </Fade>
        );
    }

    if (hasTranscript || hasAudio) {
        return <div className='' style={{ marginTop: '6px', marginRight: '7px', width: '100%' }}>
            {renderTranscriptEditor()}
        </div>
    }
    else {

        let foundAnyTrace = false;
        let foundProgress = 0.0;

        if (base.uppyFiles) {
            for (let i = 0; i < base.uppyFiles?.length; i++) {
                const uItem = base.uppyFiles[i];

                if (interviewID === uItem.meta.reservation) {
                    foundAnyTrace = true;
                    foundProgress = uItem.progress.percentage;
                }
            }
        }

        // render the new transcript widget
        return (
            <div>
                {foundAnyTrace ? (
                    <Stack
                        direction="column"
                        spacing={1}
                    >
                        <Button
                            onClick={() => {
                                // submit a request to the base atom to remove this file
                                // the custom-navigation-handler will watch that flag as an useEffect
                                // it'll perform the cancel operation & then this component should
                                // notice the change in assembly progress & re-render
                            }}
                        >
                            Cancel
                        </Button>
                        <LinearProgress
                            variant="determinate"
                            className="iw-progress"
                            value={foundProgress}
                        />
                    </Stack>
                ) : (
                    showTranscriptUploader ? (
                        <TranscriptUploader />
                    ) : null
                )}
            </div>
        );
    }
}
